/* eslint-disable no-debugger */
import Cookie from 'js-cookie';

const LOCAL_DOMAIN = 'local.digi-v.nl';
const API_VERSION = 'v1.0';

class Environment {
  protected apiVersion: string;
  protected local: string;

  public constructor(localDomain: string, apiVersion: string) {
    this.apiVersion = apiVersion;
    this.local = localDomain;
  }

  /**
   * @readonly
   * @type {boolean}
   * @memberof Environment
   */
  get isLocal(): boolean {
    return window.location.hostname === this.local;
  }

  /**
   * @return {*}
   * @memberof Environment
   */
  public getAPIUrl() {
    return `${this.getServerHost()}/api/${this.apiVersion}`;
  }

  public getAuthUrl() {
    const tenant = Cookie.get('__tenant');
    return tenant ? `${this.getServerHost()}/auth/login/${tenant}` : undefined;
  }

  public getServerHost() {
    const host = this.isLocal ? 'ont.digi-v.nl' : window.location.hostname;
    return [window.location.protocol, '//', host].filter(Boolean).join('');
  }

  public getLogoutURL() {
    return `${this.getServerHost()}/auth/local/signout`;
  }

  public getRefreshURL(tenant: string) {
    return `${this.getServerHost()}/auth/refresh/${tenant}`;
  }

  /**
   * @return {*}
   * @memberof Environment
   */
  public hasSession() {
    return Cookie.get('__session') != undefined;
  }
}

export const environment = new Environment(LOCAL_DOMAIN, API_VERSION);
